<template>
  <div class="bg-white shadow rounded-lg">
    <component
      :title="slideoverTitle"
      :is="slideoverComponent"
      :visible="slideoverVisible"
      v-on:toggle-slideover="toggleSlideover"
      :phase3d_care_app="phase3d_care_app"
    />

    <tabs>
      <!-- Totals Details Tab -->
      <tab title="Totals">
        <div class="px-4 py-4 overflow-y-visible">
          <!-- Action Button -->
          <div
            v-if="canShowActions"
            class="flex flex1 flex-row justify-end mb-2"
          >
            <ActionsMenu>
              <ActionsItem
                @click="
                  toggleSlideover('EditShippingSlideover', 'Edit Shipping')
                "
              >
                Edit Shipping
              </ActionsItem>
              <ActionsItem
                @click="toggleSlideover('AddDiscountSlideover', 'Add Discount')"
              >
                Add Discount
              </ActionsItem>
              <ActionsItem
                @click="toggleSlideover('AddCouponSlideover', 'Add Coupon')"
              >
                Add Coupon
              </ActionsItem>
              <ActionsItem
                @click="toggleSlideover('EditTaxSlideover', 'Edit Tax')"
              >
                Edit Tax
              </ActionsItem>
              <ActionsItem
                @click="
                  toggleSlideover('StoreCreditSlideover', 'Create Store Credit')
                "
              >
                Create Store Credit
              </ActionsItem>
            </ActionsMenu>
          </div>

          <!-- Totals -->
          <div class="flex flex1 flex-row font-bold border-b border-gray-300">
            <div class="w-1/2"></div>
            <div class="w-1/4">Original</div>
            <div class="w-1/4">Revised</div>
          </div>
          <div
            v-for="(total, index) in totals"
            :key="total.title"
            class="flex flex1 flex-row"
            :class="{
              'font-bold border-t border-gray-300': index == totals.length - 1,
            }"
          >
            <div class="w-1/2">{{ total.title }}</div>
            <div class="w-1/4">{{ total.original | currency }}</div>
            <div class="w-1/4">{{ total.revised | currency }}</div>
          </div>
        </div>
      </tab>
    </tabs>
  </div>
</template>

<script>
import moneyFormatter from "@/mixins/moneyFormatter";
import Tabs from "@/components/elements/Tabs.vue";
import Tab from "@/components/elements/Tab.vue";
import Button from "@/components/elements/Button.vue";
import EditShippingSlideover from "./slideovers/EditShipping.vue";
import StoreCreditSlideover from "./slideovers/StoreCredit.vue";
import AddDiscountSlideover from "./slideovers/AddDiscount.vue";
import AddCouponSlideover from "./slideovers/AddCoupon.vue";
import EditTaxSlideover from "./slideovers/EditTax.vue";

export default {
  name: "OrderTotals",
  props: {
    order: {
      type: Object,
      required: true,
    },
    phase3d_care_app: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showActionsMenu: false,
      slideoverVisible: false,
      slideoverComponent: null,
      slideoverTitle: "",
    };
  },
  components: {
    Tabs,
    Tab,
    Button,
    EditShippingSlideover,
    StoreCreditSlideover,
    AddDiscountSlideover,
    AddCouponSlideover,
    EditTaxSlideover,
  },
  mixins: [moneyFormatter],
  computed: {
    totals() {
      return [
        {
          title: "Product Total",
          original: this.order.ProductTotal,
          revised: this.order.FinalProductTotal,
        },
        {
          title: "Charges",
          original: this.order.Surcharge,
          revised: this.order.RevisedSurcharge,
        },
        {
          title: "Discounts",
          original: this.order.Discount,
          revised: this.order.RevisedDiscount,
        },
        {
          title: "Coupon",
          original: this.order.CouponDiscount,
          revised: this.order.RevisedCouponDiscount,
        },
        {
          title: "Tax",
          original: this.order.TaxTotal,
          revised: this.order.FinalTaxTotal,
        },
        {
          title: "Shipping",
          original: this.order.ShippingTotal,
          revised: this.order.FinalShippingTotal,
        },
        {
          title: "Grand Total",
          original: this.order.GrandTotal,
          revised: this.order.FinalGrandTotal,
        },
      ];
    },
    canShowActions() {
      if (this.order.status?.Status === "Unprocessed") return false;

      return this.orderWasPlacedOnShopify && !this.orderIsCancelled;
    },
    orderWasPlacedOnShopify() {
      return [22, 23, 31, 32].indexOf(Number(this.order.CartID)) > -1;
    },
    orderIsCancelled() {
      return Number(this.order.Cancelled);
    },
  },
  beforeMount() {},
  methods: {
    toggleActionsMenu() {
      this.showActionsMenu = !this.showActionsMenu;
    },
    toggleSlideover(component, title) {
      if (!this.slideoverVisible) this.toggleActionsMenu();

      this.slideoverComponent = component;
      this.slideoverTitle = title;

      // TODO better way to handle this, I'm using a timeout to allow for the proper transition effect
      setTimeout(() => {
        this.slideoverVisible = !this.slideoverVisible;
      }, 3);
    },
  },
  filters: {
    currency: (val) => {
      return moneyFormatter.format(val);
    },
  },
};
</script>

<style scoped lang="scss">
.menuItem {
  @apply block w-full px-4 py-2 text-sm leading-5 text-gray-700 text-left;
}

.menuItem:hover {
  @apply bg-gray-100 text-gray-900;
}

.menuItem:focus {
  @apply outline-none bg-gray-100 text-gray-900;
}

.menuItemDisabled {
  @apply menuItem text-gray-400;
}
</style>
